export default __webpack_public_path__ + "static/media/analysis.15f1977d.jpg";